/*
 * "Read more" popups on Furbuddy product cards.
 *
 * One delegated listener on the document rather than a handler per card: the
 * card snippet renders many times per page (and again on every theme-editor
 * re-render, and inside Swiper-cloned slides), so per-card binding would stack
 * duplicates. Delegation also covers cards injected after load.
 *
 * The snippet emits this script tag once per card, so the whole file is
 * guarded — repeated tags fetch from cache and then no-op.
 */
(function () {
  if (window.__fbCardReadMoreInit) return;
  window.__fbCardReadMoreInit = true;

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var opener = target.closest('[data-fb-readmore-open]');
    if (opener) {
      var dialog = document.getElementById(opener.getAttribute('data-fb-readmore-open'));
      // No dialog support: leave the click alone so the anchor still
      // navigates to the product page.
      if (!dialog || typeof dialog.showModal !== 'function') return;
      event.preventDefault();
      dialog.showModal();
      return;
    }

    if (target.closest('[data-fb-readmore-close]')) {
      var open = target.closest('dialog');
      if (open) open.close();
      return;
    }

    // Backdrop click. The backdrop is not a child element, so a click that
    // lands on the dialog box itself — rather than the panel inside it — is
    // the signal to close.
    if (target.matches && target.matches('dialog.fb-card__dialog')) {
      target.close();
    }
  });

  // The theme editor can re-render a section while a dialog is open, which
  // would otherwise leave the page with an inert background and no way back.
  document.addEventListener('shopify:section:unload', function () {
    document.querySelectorAll('dialog.fb-card__dialog[open]').forEach(function (dialog) {
      dialog.close();
    });
  });
})();
